import React from "react";
import { $t } from '@/modules/i18n';
import { transformArray } from '@/utils/helper';

function List({ list, index }) {
  return list && list.length ? (
    <div className={`theme-section-list theme-list-${index}`}>
    {
      list.map(item => (
        <div className="theme-section-item" key={item.text}>
          <p className="theme-section-item-text">{$t(item.text)}</p>
          <List list={item.list} index={index + 1} />
        </div>
      ))
    }
    </div>
  ) : null
}

export default ({ message }) => (
  <section id="theme" className="theme">
    <h2 className="section-title">{$t(message.title)}</h2>
    <p className="theme-title">{$t(message.title1)}</p>
    <div>
    {
      message.sections.map((section, i) => {
        const descList = transformArray(section.desc)
        return (
          <div className={`theme-section-wrapper theme-section-wrapper-${i + 1}`} key={section.title}>
            <div className="theme-section-title">{$t(section.title)}</div>
            {
              descList.map(desc => desc ? <p key={desc} className="theme-section-desc">{desc}</p> : null)
            }
            <List list={section.list} index={1} />
          </div>
        )
      })
    }
    </div>
  </section>
);
